import React from 'react';

const Home = () => (
  <section className="home" data-testid="home-page">
    <h4>Welcome to Math Magicians!</h4>
    <br />
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates eos
      deleniti, ex amet adipisci eveniet, optio reiciendis velit iusto fugiat
      placeat sunt, omnis error atque. Quis officiis sit ad ratione.
    </p>
    <br />
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis nisi
      perferendis, tenetur tempore corrupti exercitationem velit, repellendus
      nulla quibusdam voluptatibus fugit doloribus magni eos beatae officiis cum
      aspernatur dolore autem?
    </p>
  </section>
);

export default Home;
